import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import IconArrowDropdown from "../../iconComponents/IconArrowDropdown";
import {alphabetizeByAttribute} from "../../common/Helpers";

export function ManagementDrop(props) {

    const projectDrop = useSelector(state => state.projects.projectDrop);
    const contractDrop = useSelector(state => state.contract.contractDrop);

    const [open, setOpen] = useState(false);
    const [hoverArrow, setHoverArrow] = useState(false);
    const [hoverTitle, setHoverTitle] = useState(false);

    const orderedList = alphabetizeByAttribute(props.list, props.itemNameKey)

    // if click-out-of element is clicked from anywhere, ensure dropdown is closed
    useEffect(() => {
        (!props.anyDropOpen && open) && setOpen(false);
    }, [props.anyDropOpen])

    // toggle both dropdown & click-out-of element
    const toggleDrop = () => {
        let newSetting = !open;
            setOpen(newSetting);
            props.setAnyDropOpen(newSetting);
    }

    const handleSelectItem = (item) => {
        props.selectItem(props.dropId, item);
        setOpen(false);
        props.setAnyDropOpen(false);
    }

    const handleSelectAll = () => {
        props.selectAll(props.dropId);
        setOpen(false);
        props.setAnyDropOpen(false);
    }

    const selectedStyle = props.activeTab === props.dropId ? "selected-tab" : "";
    const openStyle = open ? "open" : "";
    const pathClass = hoverArrow ? "g2-fill" : (props.activeTab === props.dropId ? "p-fill" : "g6-fill");
    const arrowTransform = open ? "scale(1.2) translate(0, -15%)" : (hoverArrow ? "scale(1.2) translate(0, -15%) rotate(-90deg)" : "translate(0, -15%) rotate(-90deg)")

    const itemName = 
        props.selection[props.itemIdKey] 
        ? (props.selection[props.itemNameKey] ? props.selection[props.itemNameKey] : "Untitled Draft")
        : (props.new
            ? "New"
            : ((props.activeTab === props.dropId || hoverTitle) ? "All" : "")
          )


    return (
        <>
            <div id={`to_all_${props.dropId}s`} className={`drop-child drop-heading ${props.dropId} drop-shadow ${selectedStyle}`} onClick={() => props.toListAll(props.dropId)}>
                <h2 className={`content1 iblock heavy-grey`}>{props.heading}</h2>
                {props.alertCount > 0 && <div className="alert-count p iblock gap-left-xxs" >{props.alertCount}</div>}
            </div>

            <div id={`to_filtered_${props.dropId}s`} className={`drop-child drop ${props.dropId} drop-shadow flex-row ${selectedStyle} ${openStyle}`} >
                    
            {(props.emptyListReturned || props.fullList.length > 0) &&
                <>
                    <div className="flex-row center drop-arrow" 
                        onClick={() => toggleDrop()}
                        onMouseEnter={() => setHoverArrow(true)} 
                        onMouseLeave={() => setHoverArrow(false)} >
                        <IconArrowDropdown 
                            className="iblock" 
                            height="7px" 
                            marg="0 6px" 
                            pathClass="g2-fill"
                            transform={arrowTransform} 
                            transition=".2s"
                        />
                    </div>
                    <div className="w100" style={{paddingRight: "12px"}}>
                        <div className="drop-selection-item title2 light-black" >
                            <div 
                                className="w100" 
                                onClick={() => props.selection[props.itemNameKey] ? handleSelectItem(props.selection) : handleSelectAll()} 
                                onMouseEnter={() => setHoverTitle(true)}
                                onMouseLeave={() => setHoverTitle(false)}
                            >
                                <div style={{overflow: "hidden", textOverflow: "ellipsis"}}>
                                    <h2>{itemName}</h2> 
                                </div>
                            </div>
                            {open &&
                            <ul>
                                <li className="title2 heavy" key="0" onClick={() => handleSelectAll()}>
                                    <div>All</div>
                                </li>
                            {orderedList.map((item) => {
                                return (
                                    <li className="content1 light-black" key={item[props.itemIdKey]} onClick={() => handleSelectItem(item)}>
                                        <div>{item[props.itemNameKey] ? item[props.itemNameKey] : "Untitled Draft"}</div>
                                    </li>
                                )})
                            }
                            </ul>}
                        </div>
                    </div>
                </>}
            </div>
            
        </>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(ManagementDrop);

